import sun from "../../../asset/sun.png";
import earth from "../../../asset/earth.png";
import Mars from "../../../asset/mars.png";
import Mercury from "../../../asset/mercury.png";
import Saturn from "../../../asset/Saturn.png";
import Jupiter from "../../../asset/Jupiter.png";
import Uranus from "../../../asset/Uranus.png";

export const planetData = [
  {
    id: 1,
    title: "Orbit 1",
    layout: [
      {
        planet: [
          {
            value: "Sun",
            planetImg: sun,
          },

          {
            value: "Earth",
            planetImg: earth,
          },
        ],
      },

      {
        planet: [
          {
            value: "Mercury",
            planetImg: Mercury,
          },

          {
            value: "Mars",
            planetImg: Mars,
          },
        ],
      },
      {
        planet: [
          {
            value: "Uranus",
            planetImg: Uranus,
          },
          {
            value: "Saturn",
            planetImg: Saturn,
          },
          {
            value: "Jupiter",
            planetImg: Jupiter,
          },
        ],
      },
    ],
  },
  {
    id: 2,
    title: "Orbit 2",
    layout: [
      {
        planet: [
          {
            value: "Sun",
            planetImg: sun,
          },

          {
            value: "Earth",
            planetImg: earth,
          },
        ],
      },

      {
        planet: [
          {
            value: "Mercury",
            planetImg: Mercury,
          },

          {
            value: "Mars",
            planetImg: Mars,
          },
        ],
      },
      {
        planet: [
          {
            value: "Uranus",
            planetImg: Uranus,
          },
          {
            value: "Saturn",
            planetImg: Saturn,
          },
          {
            value: "Jupiter",
            planetImg: Jupiter,
          },
        ],
      },
    ],
  },
  {
    id: 3,
    title: "Orbit 3",
    layout: [
      {
        planet: [
          {
            value: "Sun",
            planetImg: sun,
          },

          {
            value: "Earth",
            planetImg: earth,
          },
        ],
      },

      {
        planet: [
          {
            value: "Mercury",
            planetImg: Mercury,
          },

          {
            value: "Mars",
            planetImg: Mars,
          },
        ],
      },
      {
        planet: [
          {
            value: "Uranus",
            planetImg: Uranus,
          },
          {
            value: "Saturn",
            planetImg: Saturn,
          },
          {
            value: "Jupiter",
            planetImg: Jupiter,
          },
        ],
      },
    ],
  },
  {
    id: 4,
    title: "Orbit 4",
    layout: [
      {
        planet: [
          {
            value: "Sun",
            planetImg: sun,
          },

          {
            value: "Earth",
            planetImg: earth,
          },
        ],
      },

      {
        planet: [
          {
            value: "Mercury",
            planetImg: Mercury,
          },

          {
            value: "Mars",
            planetImg: Mars,
          },
        ],
      },
      {
        planet: [
          {
            value: "Uranus",
            planetImg: Uranus,
          },
          {
            value: "Saturn",
            planetImg: Saturn,
          },
          {
            value: "Jupiter",
            planetImg: Jupiter,
          },
        ],
      },
    ],
  },
  {
    id: 5,
    title: "Orbit 5",
    layout: [
      {
        planet: [
          {
            value: "Sun",
            planetImg: sun,
          },

          {
            value: "Earth",
            planetImg: earth,
          },
        ],
      },

      {
        planet: [
          {
            value: "Mercury",
            planetImg: Mercury,
          },

          {
            value: "Mars",
            planetImg: Mars,
          },
        ],
      },
      {
        planet: [
          {
            value: "Uranus",
            planetImg: Uranus,
          },
          {
            value: "Saturn",
            planetImg: Saturn,
          },
          {
            value: "Jupiter",
            planetImg: Jupiter,
          },
        ],
      },
    ],
  },
  {
    id: 6,
    title: "Orbit 6",
    layout: [
      {
        planet: [
          {
            value: "Sun",
            planetImg: sun,
          },

          {
            value: "Earth",
            planetImg: earth,
          },
        ],
      },

      {
        planet: [
          {
            value: "Mercury",
            planetImg: Mercury,
          },

          {
            value: "Mars",
            planetImg: Mars,
          },
        ],
      },
      {
        planet: [
          {
            value: "Uranus",
            planetImg: Uranus,
          },
          {
            value: "Saturn",
            planetImg: Saturn,
          },
          {
            value: "Jupiter",
            planetImg: Jupiter,
          },
        ],
      },
    ],
  },
  {
    id: 7,
    title: "Orbit 7",
    layout: [
      {
        planet: [
          {
            value: "Sun",
            planetImg: sun,
          },

          {
            value: "Earth",
            planetImg: earth,
          },
        ],
      },

      {
        planet: [
          {
            value: "Mercury",
            planetImg: Mercury,
          },

          {
            value: "Mars",
            planetImg: Mars,
          },
        ],
      },
      {
        planet: [
          {
            value: "Uranus",
            planetImg: Uranus,
          },
          {
            value: "Saturn",
            planetImg: Saturn,
          },
          {
            value: "Jupiter",
            planetImg: Jupiter,
          },
        ],
      },
    ],
  },
  {
    id: 8,
    title: "Orbit 8",
    layout: [
      {
        planet: [
          {
            value: "Sun",
            planetImg: sun,
          },

          {
            value: "Earth",
            planetImg: earth,
          },
        ],
      },

      {
        planet: [
          {
            value: "Mercury",
            planetImg: Mercury,
          },

          {
            value: "Mars",
            planetImg: Mars,
          },
        ],
      },
      {
        planet: [
          {
            value: "Uranus",
            planetImg: Uranus,
          },
          {
            value: "Saturn",
            planetImg: Saturn,
          },
          {
            value: "Jupiter",
            planetImg: Jupiter,
          },
        ],
      },
    ],
  },
  {
    id: 9,
    title: "Orbit 9",
    layout: [
      {
        planet: [
          {
            value: "Sun",
            planetImg: sun,
          },

          {
            value: "Earth",
            planetImg: earth,
          },
        ],
      },

      {
        planet: [
          {
            value: "Mercury",
            planetImg: Mercury,
          },

          {
            value: "Mars",
            planetImg: Mars,
          },
        ],
      },
      {
        planet: [
          {
            value: "Uranus",
            planetImg: Uranus,
          },
          {
            value: "Saturn",
            planetImg: Saturn,
          },
          {
            value: "Jupiter",
            planetImg: Jupiter,
          },
        ],
      },
    ],
  },
  {
    id: 10,
    title: "Orbit 10",
    layout: [
      {
        planet: [
          {
            value: "Sun",
            planetImg: sun,
          },

          {
            value: "Earth",
            planetImg: earth,
          },
        ],
      },

      {
        planet: [
          {
            value: "Mercury",
            planetImg: Mercury,
          },

          {
            value: "Mars",
            planetImg: Mars,
          },
        ],
      },
      {
        planet: [
          {
            value: "Uranus",
            planetImg: Uranus,
          },
          {
            value: "Saturn",
            planetImg: Saturn,
          },
          {
            value: "Jupiter",
            planetImg: Jupiter,
          },
        ],
      },
    ],
  },
];
